//
// Regular

import {
  faBookmark as farBookmark,
  faCalendar as farCalendar,
  faCircle as farCircle,
  faClock as farClock,
  faClone as farClone,
  faDotCircle as farDotCircle,
  faFile as farFile,
  faFileArchive as farFileArchive,
  faFileAudio as farFileAudio,
  faFolder as farFolder,
  faObjectGroup as farObjectGroup,
  faHdd as farHdd,
  faKeyboard as farKeyboard,
  faObjectUngroup as farObjectUngroup
} from '@fortawesome/free-regular-svg-icons';

//
// Solid

import {
  faArrowCircleLeft as fasArrowCircleLeft,
  faArrowCircleRight as fasArrowCircleRight,
  faArrowCircleUp as fasArrowCircleUp,
  faLongArrowAltRight as fasLongArrowAltRight,
  faBackward as fasBackward,
  faBan as fasBan,
  faBars as fasBars,
  faBolt as fasBolt,
  faBookmark as fasBookmark,
  faBookReader as fasBookReader,
  faBug as fasBug,
  faBroadcastTower as fasBroadcastTower,
  faCalendarAlt as fasCalendarAlt,
  faCaretDown as fasCaretDown,
  faCheck as fasCheck,
  faChevronCircleDown as fasChevronCircleDown,
  faChevronCircleRight as fasChevronCircleRight,
  faChevronCircleUp as fasChevronCircleUp,
  faCheckCircle as fasCheckCircle,
  faCircle as fasCircle,
  faCloudDownloadAlt as fasCloudDownloadAlt,
  faCloud as fasCloud,
  faCog as fasCog,
  faCogs as fasCogs,
  faCopy as fasCopy,
  faDesktop as fasDesktop,
  faDownload as fasDownload,
  faEdit as fasEdit,
  faEllipsisH as fasEllipsisH,
  faExclamationCircle as fasExclamationCircle,
  faExclamationTriangle as fasExclamationTriangle,
  faExternalLinkAlt as fasExternalLinkAlt,
  faEye as fasEye,
  faFastBackward as fasFastBackward,
  faFastForward as fasFastForward,
  faFileImport as fasFileImport,
  faFileInvoice as farFileInvoice,
  faFilter as fasFilter,
  faFolderOpen as fasFolderOpen,
  faForward as fasForward,
  faHeart as fasHeart,
  faHistory as fasHistory,
  faHome as fasHome,
  faInfoCircle as fasInfoCircle,
  faLaptop as fasLaptop,
  faLevelUpAlt as fasLevelUpAlt,
  faMedkit as fasMedkit,
  faMinus as fasMinus,
  faPause as fasPause,
  faPlay as fasPlay,
  faPlus as fasPlus,
  faPowerOff as fasPowerOff,
  faQuestion as fasQuestion,
  faQuestionCircle as fasQuestionCircle,
  faRedoAlt as fasRedoAlt,
  faRetweet as fasRetweet,
  faRss as fasRss,
  faRocket as fasRocket,
  faSave as fasSave,
  faSearch as fasSearch,
  faSignOutAlt as fasSignOutAlt,
  faSitemap as fasSitemap,
  faSpinner as fasSpinner,
  faSort as fasSort,
  faSortDown as fasSortDown,
  faSortUp as fasSortUp,
  faStar as fasStar,
  faStop as fasStop,
  faSync as fasSync,
  faTags as fasTags,
  faTable as fasTable,
  faTh as fasTh,
  faThList as fasThList,
  faTrashAlt as fasTrashAlt,
  faTimes as fasTimes,
  faTimesCircle as fasTimesCircle,
  faUser as fasUser,
  faUserPlus as fasUserPlus,
  faVial as fasVial,
  faWrench as fasWrench
} from '@fortawesome/free-solid-svg-icons';

//
// Icons

export const ACTIONS = fasBolt;
export const ACTIVITY = farClock;
export const ADD = fasPlus;
export const ALTERNATE_TITLES = farClone;
export const ADVANCED_SETTINGS = fasCog;
export const ARROW_LEFT = fasArrowCircleLeft;
export const ARROW_RIGHT = fasArrowCircleRight;
export const ARROW_RIGHT_NO_CIRCLE = fasLongArrowAltRight;
export const ARROW_UP = fasArrowCircleUp;
export const BACKUP = farFileArchive;
export const BAN = fasBan;
export const BUG = fasBug;
export const CALENDAR = fasCalendarAlt;
export const CALENDAR_O = farCalendar;
export const CARET_DOWN = fasCaretDown;
export const CHECK = fasCheck;
export const CHECK_INDETERMINATE = fasMinus;
export const CHECK_CIRCLE = fasCheckCircle;
export const CIRCLE = fasCircle;
export const CIRCLE_OUTLINE = farCircle;
export const CLEAR = fasTrashAlt;
export const CLIPBOARD = fasCopy;
export const CLOSE = fasTimes;
export const CLONE = farClone;
export const COLLAPSE = fasChevronCircleUp;
export const COMPUTER = fasDesktop;
export const DANGER = fasExclamationCircle;
export const DELETE = fasTrashAlt;
export const DOWNLOAD = fasDownload;
export const DOWNLOADED = fasDownload;
export const DOWNLOADING = fasCloudDownloadAlt;
export const DRIVE = farHdd;
export const EDIT = fasWrench;
export const TRACK_FILE = farFileAudio;
export const EXPAND = fasChevronCircleDown;
export const EXPAND_INDETERMINATE = fasChevronCircleRight;
export const EXTERNAL_LINK = fasExternalLinkAlt;
export const FATAL = fasTimesCircle;
export const FILE = farFile;
export const FILEIMPORT = fasFileImport;
export const FILTER = fasFilter;
export const FOLDER = farFolder;
export const FOLDER_OPEN = fasFolderOpen;
export const GROUP = farObjectGroup;
export const HEALTH = fasMedkit;
export const HEART = fasHeart;
export const HISTORY = fasHistory;
export const HOUSEKEEPING = fasHome;
export const INFO = fasInfoCircle;
export const INTERACTIVE = fasUser;
export const KEYBOARD = farKeyboard;
export const LOGOUT = fasSignOutAlt;
export const MEDIA_INFO = farFileInvoice;
export const MISSING = fasExclamationTriangle;
export const MONITORED = fasBookmark;
export const NETWORK = fasBroadcastTower;
export const NAVBAR_COLLAPSE = fasBars;
export const NOT_AIRED = farClock;
export const ORGANIZE = fasSitemap;
export const OVERFLOW = fasEllipsisH;
export const OVERVIEW = fasThList;
export const PAGE_FIRST = fasFastBackward;
export const PAGE_PREVIOUS = fasBackward;
export const PAGE_NEXT = fasForward;
export const PAGE_LAST = fasFastForward;
export const PARENT = fasLevelUpAlt;
export const PAUSED = fasPause;
export const PENDING = farClock;
export const PROFILE = fasUser;
export const POSTER = fasTh;
export const QUEUED = fasCloud;
export const QUICK = fasRocket;
export const REFRESH = fasSync;
export const REMOVE = fasTimes;
export const REORDER = fasBars;
export const RESTART = fasRedoAlt;
export const RESTORE = fasHistory;
export const RETAG = fasEdit;
export const RSS = fasRss;
export const SAVE = fasSave;
export const SCHEDULED = farClock;
export const SCORE = fasUserPlus;
export const SEARCH = fasSearch;
export const ARTIST_CONTINUING = fasPlay;
export const ARTIST_ENDED = fasStop;
export const SETTINGS = fasCogs;
export const SHUTDOWN = fasPowerOff;
export const SORT = fasSort;
export const SORT_ASCENDING = fasSortUp;
export const SORT_DESCENDING = fasSortDown;
export const SPINNER = fasSpinner;
export const STAR_FULL = fasStar;
export const SUBTRACT = fasMinus;
export const SYSTEM = fasLaptop;
export const TABLE = fasTable;
export const TAGS = fasTags;
export const TBA = fasQuestionCircle;
export const TEST = fasVial;
export const UNGROUP = farObjectUngroup;
export const UNKNOWN = fasQuestion;
export const UNMONITORED = farBookmark;
export const UPDATE = fasRetweet;
export const UNSAVED_SETTING = farDotCircle;
export const VIEW = fasEye;
export const WARNING = fasExclamationTriangle;
export const WIKI = fasBookReader;
